(function () {
    'use strict';
    /**
     * @memberof appback
     *@ngdoc service
     *@name KanbanService
     *@description
     *Servicio de autores
     */

    angular
        .module('appback')
        .factory('KanbanService', KanbanService);

    KanbanService.$inject = ["$http"];

    function KanbanService($http) {

        var service = {
            Getcards: Getcards,
            Getcard: Getcard,
            UpdateStateCard: UpdateStateCard,
            CreateState: CreateState,
            CreateCard: CreateCard,
            UpdateCard: UpdateCard,
            UpdateStateName: UpdateStateName,
            DeleteState: DeleteState,
            LogCardHours: LogCardHours,
            CloneCard: CloneCard,
            DeleteCard: DeleteCard,
            ArchiveCard: ArchiveCard,
            UnarchiveCard: UnarchiveCard,
            GetArchivedCards: GetArchivedCards,
            CancelCard: CancelCard,
            GetMaintenanceApplications: GetMaintenanceApplications,
            GetMachines: GetMachines,
            GetCorrectiveOts: GetCorrectiveOts,
            DeleteCardFile: DeleteCardFile,
            UploadCardFile: UploadCardFile,
            ImportOts: ImportOts,
            GetWarehouses: GetWarehouses,
            GetPetitionProducts: GetPetitionProducts,
            GetServiceProducts: GetServiceProducts,
            GetCurrentPersonal: GetCurrentPersonal,
            GetCostCenters: GetCostCenters,
            CreateCardPetition: CreateCardPetition,
            CreateCardReturn: CreateCardReturn,
            GetLineHistories: GetLineHistories,
            GetUsers: GetUsers,
            GetCurrentUser: GetCurrentUser,
            GetBoards: GetBoards,
            GetComments: GetComments,
            NewComment: NewComment,
            GetHistory: GetHistory,
            NewHistory: NewHistory,
            GetTasks: GetTasks,
            GetPredefinedTasks: GetPredefinedTasks,
            NewTask: NewTask,
            NewTasks: NewTasks,
            StartTask: StartTask,
            EndTask: EndTask,
            DeleteTask: DeleteTask,
            AcceptCard: AcceptCard,
            DeclineCard: DeclineCard,
            GetState: GetState,
            UpdateState: UpdateState,
            SearchCards: SearchCards,
            SetRelatedCards: SetRelatedCards,
            SetParentCard: SetParentCard,
            SetMachineStart: SetMachineStart
        };

        function SetParentCard(cardId, parentId) {
            return $http.post('/backend/kanban/set-parent-card', {
                cardID: cardId,
                parentID: parentId || null
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function SetMachineStart(cardId, machineStart) {
            return $http.post('/backend/kanban/set-machine-start', {
                cardID: cardId,
                machine_start: machineStart || ''
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function SearchCards(search, excludeIds) {
            return $http.get('/backend/kanban/search-cards', {
                params: {
                    search: search || '',
                    exclude: (excludeIds || []).join(',')
                }
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function SetRelatedCards(cardId, relatedIds) {
            return $http.post('/backend/kanban/set-related-cards', {
                cardID: cardId,
                relatedIDs: relatedIds || []
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function Getcards() {
            return $http.get('/backend/kanban/getcards', {
                params: {
                    id: id
                },
                headers: {}
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function Getcard(id) {
            return $http.get('/backend/kanban/get-card', {
                params: {
                    id: id
                },
                headers: {}
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function UpdateStateCard(cardId, stateId) {

            return $http.post(
                '/backend/kanban/update-state-card',
                {
                    cardID: cardId,
                    stateID: stateId
                },
                {
                    headers: {}
                }
            ).then(function (response) {

                return response.data;

            });
        }

        function CreateState(state) {
            return $http.post('/backend/kanban/new-state', {
                name: state.name,
                responsable_id: state.responsable_id,
                max_time: state.max_time,
                expire_action: state.expire_action,
                assign_to: state.assign_to,
                board: state.board
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetState(stateId) {
            return $http.get('/backend/kanban/get-state', {
                params: {
                    id: stateId
                },
                headers: {}
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function UpdateState(state) {
            return $http.post('/backend/kanban/update-state', {
                stateID: state.id,
                name: state.name,
                responsable_id: state.responsable_id,
                max_time: state.max_time,
                expire_action: state.expire_action,
                assign_to: state.assign_to
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function CreateCard(card) {
            return $http.post('/backend/kanban/new-card', {
                card: card
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function UpdateCard(card) {
            return $http.post('/backend/kanban/update-card', {
                card: card
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function UpdateStateName(stateId, name) {
            return $http.post('/backend/kanban/update-state-name', {
                stateID: stateId,
                name: name
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function DeleteState(stateId) {
            return $http.post('/backend/kanban/delete-state', {
                stateID: stateId
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function LogCardHours(payload) {
            return $http.post('/backend/kanban/log-card-hours', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function CloneCard(cardId) {
            return $http.post('/backend/kanban/clone-card', {
                cardID: cardId
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function DeleteCard(cardId) {
            return $http.post('/backend/kanban/delete-card', {
                cardID: cardId
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function ArchiveCard(cardId) {
            return $http.post('/backend/kanban/archive-card', {
                cardID: cardId
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function UnarchiveCard(cardId) {
            return $http.post('/backend/kanban/unarchive-card', {
                cardID: cardId
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetArchivedCards(boardId) {
            return $http.get('/backend/kanban/get-archived-cards', {
                params: { board: boardId || '' }
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function CancelCard(cardId, cancelled) {
            return $http.post('/backend/kanban/cancel-card', {
                cardID: cardId,
                cancelled: cancelled
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetMaintenanceApplications() {
            return $http.get('/backend/kanban/get-maintenance-applications').then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetMachines() {
            return $http.get('/backend/kanban/get-machines').then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetWarehouses() {
            return $http.get('/backend/kanban/get-warehouses').then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetPetitionProducts(search, offset, limit, warehouseId) {
            return $http.get('/backend/kanban/get-petition-products', {
                params: {
                    search: search || '',
                    offset: offset || 0,
                    limit: limit || 30,
                    warehouse: warehouseId || ''
                }
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetServiceProducts(search, offset, limit) {
            return $http.get('/backend/kanban/get-service-products', {
                params: {
                    search: search || '',
                    offset: offset || 0,
                    limit: limit || 50
                }
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetCurrentPersonal() {
            return $http.get('/backend/kanban/get-current-personal').then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetCostCenters() {
            return $http.get('/backend/kanban/get-cost-centers').then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function CreateCardPetition(payload) {
            return $http.post('/backend/kanban/create-card-petition', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function CreateCardReturn(payload) {
            return $http.post('/backend/kanban/create-card-return', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function UploadCardFile(cardId, file) {

            var formData = new FormData();

            formData.append('cardID', cardId);
            formData.append('file', file);

            // Content-Type undefined: el navegador pone multipart/form-data con
            // su boundary. El token CSRF lo añade la configuración global.
            return $http.post('/backend/kanban/upload-card-file', formData, {
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function ImportOts(file, boardId, dryRun) {

            var formData = new FormData();

            formData.append('file', file);
            formData.append('board', boardId || '');
            formData.append('dryRun', dryRun ? 1 : 0);

            return $http.post('/backend/kanban/import-ots', formData, {
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function DeleteCardFile(cardId, fileId) {
            return $http.post('/backend/kanban/delete-card-file', {
                cardID: cardId,
                fileID: fileId
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetCorrectiveOts() {
            return $http.get('/backend/kanban/get-corrective-ots').then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetLineHistories(lineId, currentId) {
            return $http.get('/backend/kanban/get-line-histories', {
                params: {
                    line: lineId || null,
                    current: currentId || null
                }
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetUsers() {
            return $http.get('/backend/kanban/get-users', {
                headers: {}
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetCurrentUser() {
            return $http.get('/backend/kanban/get-current-user', {
                headers: {}
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetBoards() {
            return $http.get('/backend/kanban/get-boards', {
                headers: {}
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetComments(cardId) {
            return $http.get('/backend/kanban/get-comments', {
                params: {
                    id: cardId
                },
                headers: {}
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        };

        function NewComment(commentData) {
            return $http.post('/backend/kanban/new-comment', {
                commentData: commentData
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        };

        function GetHistory(cardId) {
            return $http.get('/backend/kanban/get-history', {
                params: {
                    id: cardId
                },
                headers: {}
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        };

        function NewHistory(historyData) {
            return $http.post('/backend/kanban/new-history', {
                historyData: historyData
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        };

        function GetTasks(cardId) {
            return $http.get('/backend/kanban/get-tasks', {
                params: {
                    id: cardId
                },
                headers: {}
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        };

        function GetPredefinedTasks(search, offset, limit) {
            return $http.get('/backend/kanban/get-predefined-tasks', {
                params: {
                    search: search || '',
                    offset: offset || 0,
                    limit: limit || 10
                },
                headers: {}
            }).then(function (response) {
                return response.data;
            });
        }

        function NewTask(task) {
            return $http.post('/backend/kanban/new-task', {
                task: task
            }).then(function (response) {

                return response.data;

            });
        }

        // Crea un grupo de tareas en la tarjeta con una sola entrada en el historial.
        function NewTasks(cardId, tasks) {
            return $http.post('/backend/kanban/new-tasks', {
                card: cardId,
                tasks: tasks
            }).then(function (response) {

                return response.data;

            });
        }

        function StartTask(taskId) {
            return $http.post('/backend/kanban/start-task', {
                taskID: taskId
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function EndTask(data) {
            return $http.post('/backend/kanban/end-task', data).then(function (response) {
                return response.data;
            });
        };

        function DeleteTask(taskId) {
            return $http.post('/backend/kanban/delete-task', {
                taskID: taskId
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function AcceptCard(cardId) {
            return $http.post('/backend/kanban/accept-card', {
                cardID: cardId
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function DeclineCard(cardId) {
            return $http.post('/backend/kanban/decline-card', {
                cardID: cardId
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        return service;
    }
})();

